/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Document_Delete_FailedInputs */



/**
* | output |
* | --- |
* | "Deleting did not work. Try again." |
*
* @param {Meeting_Document_Delete_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_document_delete_failed = /** @type {((inputs?: Meeting_Document_Delete_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Document_Delete_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verwijderen is niet gelukt. Probeer het opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La suppression n'a pas fonctionné. Réessayez.")
	return /** @type {LocalizedString} */ ("Deleting did not work. Try again.")
});